module.exports = __webpack_public_path__ + "img/DNR.405078ff.svg";